import SpaceMention from "$components/editor/extensions/blocks/Space/SpaceMention.svelte";
import { Node, mergeAttributes } from "@tiptap/core";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import { slugify } from "app/utils/strings";
import { docURL, spaceURL } from "app/utils/urls";
import { communitySlug } from "app/stores/community";
import { get } from "svelte/store";
import { type MarkdownSerializerState } from "prosemirror-markdown";
import { type Node as PMNode } from "@tiptap/pm/model";

export default Node.create({
  name: "spaceInlineBlock",
  group: "inline",
  inline: true,
  atom: true,
  draggable: true,
  selectable: true,
  renderText({ node }) {
    // when copy/pasted to another app
    // keep space in front to avoid triggering heading shortcut on hitting space after creating mention
    return ` #${node.attrs.space.title}`;
  },
  addAttributes() {
    return {
      space: {
        default: {},
        // serialise complex data to string
        // used when copy/pasting content
        parseHTML: (element) => JSON.parse(element.getAttribute("data-title") || ""),
        renderHTML: (attributes) => {
          return {
            "data-title": JSON.stringify(attributes.space),
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "mention-space-inline",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["mention-space-inline", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return SvelteNodeViewRenderer(SpaceMention);
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: PMNode) => {
          const { space } = node.attrs;
          const title = space.title;
          const uuid = space.uuid;
          let url;

          if (uuid.startsWith("doc")) {
            url = docURL({
              communitySlug: get(communitySlug),
              docUuid: uuid,
              docSlug: slugify(title),
            });
          } else {
            url = spaceURL({
              communitySlug: get(communitySlug),
              spaceUuid: uuid,
              spaceSlug: slugify(title),
              spaceType: space.spaceType,
            });
          }

          // format as markdown link
          state.write(`[${title}](${url})`);
        },
      },
    };
  },
});
